import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";
import { Ripple } from "primereact/ripple";
import { Slide, Fade } from 'react-awesome-reveal';
import { goToTop } from "../../WebApp/Components/goToTop";
import { SocialMedia, socialMedia } from "../Utils/Info";

const Footer: React.FC = () => {
    const navigate = useNavigate();

    const [socialMediaData, setSocialMediaData] = useState<SocialMedia[]>([]);

    useEffect(() => {
        if (socialMedia && socialMedia?.length > 0) {
            const activeData = socialMedia?.filter((item) => item?.status === 1);
            setSocialMediaData(activeData);
        } else {
            setSocialMediaData([]);
        }
    }, []);

    return (
        <React.Fragment>
            <Tooltip target=".footer_social_link" />

            <footer>
                <div className="container_padding">
                    <section className="footer_section section__padding pb-0">
                        <div className="container-md">
                            <div className="footer_contact_section">
                                <div className="section_heading_area">
                                    <Slide direction="down" triggerOnce>
                                        <h2 className="section_heading font_semi_bold text-center text-white">
                                            Still have questions?
                                        </h2>
                                    </Slide>
                                    <Slide direction="up" delay={100} triggerOnce>
                                        <p className="section_desc text-white text-center">
                                            Here are more ways to discover how we can help you.
                                        </p>
                                    </Slide>
                                </div>
                                <Slide direction="up" delay={100} triggerOnce>
                                    <div className="section_btn_area">
                                        <Link to={'/use-case'} className="tdo_button btn_fill p-ripple"
                                            onClick={goToTop}>
                                            Use case
                                            <Ripple />
                                        </Link>
                                        <Link to={'/contact-us'} className="tdo_button btn_line light p-ripple"
                                            onClick={goToTop}>
                                            Contact Us
                                            <Ripple />
                                        </Link>
                                    </div>
                                </Slide>
                            </div>
                            <div className="footer_link_section">
                                <div className="row">
                                    <div className="col-12 col-sm-6 col-xl-3 col-lg-4">
                                        <Slide direction="up" triggerOnce>
                                            <h6 className="footer_title">Get In Touch</h6>
                                        </Slide>

                                        <Fade triggerOnce>
                                            <ul className="footer_link_list">
                                                {/* <li className="has_icon">
                                                    <div className="footer_link_icon">
                                                        <i className="bi bi-telephone-fill"></i>
                                                    </div>
                                                    <Link to={'tel:+445678890'} className="footer_link">
                                                        UK +44 746 218 4536
                                                    </Link>
                                                </li> */}
                                                {/* <li className="has_icon">
                                                    <div className="footer_link_icon">
                                                        <i className="bi bi-telephone-fill"></i>
                                                    </div>
                                                    <Link to={'tel:+945678900'} className="footer_link">
                                                        SL +945678900
                                                    </Link>
                                                </li> */}
                                                <li className="has_icon">
                                                    <div className="footer_link_icon">
                                                        <i className="bi bi-envelope-fill"></i>
                                                    </div>
                                                    <Link to={'mailto:info@nuvay.co.uk'} className="footer_link">
                                                        info@nuvay.co.uk
                                                    </Link>
                                                </li>
                                                {/* <li className="has_icon">
                                                    <div className="footer_link_icon">
                                                        <i className="bi bi-geo-alt-fill"></i>
                                                    </div>
                                                    <Link to={'https://maps.app.goo.gl/6rxBgCqLWb9zgs6LA'}
                                                        target="_blank" className="footer_link">
                                                        Unit 11, Rockware Business Centre Greenford, Middlesex, UB6 0AA.
                                                    </Link>
                                                </li> */}
                                            </ul>
                                        </Fade>
                                    </div>

                                    <div className="col-6 col-sm-6 col-xl-3 col-lg-4 mt-5 mt-sm-0">
                                        <Slide direction="up" triggerOnce>
                                            <h6 className="footer_title">Traqdo</h6>
                                        </Slide>
                                        <Fade triggerOnce>
                                            <ul className="footer_link_list">
                                                <li>
                                                    <Link to={'/about-us'} className="footer_link" onClick={goToTop}>
                                                        About Us
                                                    </Link>
                                                </li>

                                                <li>
                                                    <Link to={'/pricing'} className="footer_link" onClick={goToTop}>
                                                        Pricing
                                                    </Link>
                                                </li>

                                                <li>
                                                    <Link to={'/contact-us'} className="footer_link" onClick={goToTop}>
                                                        Contact Us
                                                    </Link>
                                                </li>

                                                {/* <li>
                                                    <Link to={'/careers'} className="footer_link" onClick={goToTop}>
                                                        Careers
                                                    </Link>
                                                </li> */}
                                            </ul>
                                        </Fade>
                                    </div>

                                    <div className="col-6 col-sm-6 col-xl-3 col-lg-4 mt-5 mt-sm-5 mt-lg-0">
                                        <Slide direction="up" triggerOnce>
                                            <h6 className="footer_title">Resources</h6>
                                        </Slide>

                                        <Fade triggerOnce>
                                            <ul className="footer_link_list">
                                                <li>
                                                    <Link to={'/use-case'} className="footer_link" onClick={goToTop}>
                                                        Use Case
                                                    </Link>
                                                </li>
                                                {/* <li>
                                                    <Link to={'/blogs'} className="footer_link" onClick={goToTop}>
                                                        Blogs
                                                    </Link>
                                                </li> */}
                                                <li>
                                                    <Link to={'/faq'} className="footer_link" onClick={goToTop}>
                                                        Faq
                                                    </Link>
                                                </li>
                                            </ul>
                                        </Fade>
                                    </div>

                                    <div className="col-12 col-sm-6 col-xl-3 col-lg-12 mt-5 mt-sm-5 mt-xl-0">
                                        <Slide direction="up" triggerOnce>
                                            <h6 className="footer_title text-center text-sm-start text-lg-center text-xl-start">Follow Us</h6>
                                        </Slide>

                                        {socialMediaData && socialMediaData?.length > 0 ? (
                                            <Fade triggerOnce>
                                                <div className="footer_social_link_area">
                                                    {socialMediaData?.map((item) => {
                                                        return (
                                                            <Link
                                                                key={item?.id}
                                                                to={item?.link!}
                                                                target="_blank"
                                                                className="footer_social_link p-ripple"
                                                                data-pr-tooltip={item?.name}
                                                                data-pr-position="top"
                                                            >
                                                                <i className={item?.icon}></i>
                                                                <Ripple pt={{ root: { style: { background: 'rgba(0, 119, 181, 0.6)' } } }} />
                                                            </Link>
                                                        )
                                                    })}
                                                </div>
                                            </Fade>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="sub_footer">
                            <div className="container-md">
                                <div className="row">
                                    <div className="sub_footer_area col-12 col-xl-5">
                                        <p className="footer_copyright">Traqdo&nbsp;
                                            <i className="ri ri-copyright-line"></i>&nbsp;
                                            <span>{new Date().getFullYear()}</span>
                                        </p>
                                    </div>

                                    <div className="sub_footer_area col-12 col-xl-2 d-flex justify-content-center overflow-visible">
                                        <div className="p-ripple overflow-visible" onClick={() => { setTimeout(() => { goToTop(); navigate('/'); }, 500); }}>
                                            <img src="/assets/images/traqdo_logo_icon_light.svg" className="footer_logo cursor_pointer" alt="Traqdo" />
                                            <Ripple />
                                        </div>
                                    </div>

                                    <div className="sub_footer_area col-12 col-xl-5 d-flex justify-content-xl-end">
                                        <div className="subfooter_links">
                                            <Link to={'/privacy-policy'} className="footer_link" onClick={goToTop}>
                                                Privacy Policy
                                            </Link>
                                            <span>|</span>
                                            <Link to={'cookies-policy'} className="footer_link" onClick={goToTop}>
                                                Cookies Policy
                                            </Link>
                                            <span>|</span>
                                            <Link to={'/terms-of-service'} className="footer_link" onClick={goToTop}>
                                                Terms of Service
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </footer>
        </React.Fragment>
    )
}

export default Footer;